// import React, { useEffect, useState } from "react";
// import {
//   Button,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Grid,
//   TextField,
//   Typography,
//   createStyles,
//   makeStyles,
// } from "@material-ui/core";
// import _ from "lodash";
// import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
// import { useDispatch } from "react-redux";
// import { useForm } from "react-hook-form";
// import ValidationMessage from "../../../../../../components/validation/ValidationMessage";
// import DialogCommonDefault from "../../../../../../components/dialogs/DialogCommonDefault";
// import TextfieldDefaultNew from "../../../../../../components/textField/TextfieldDefaultNew";
// import { Autocomplete } from "@material-ui/lab";
// import { ERROR_MESSAGE_UNEXPECTED_ERROR, SUCCESSFULLY_CREATED } from "../../../../../../utils/consts";
// import { updateDirectoryInStore } from "../../../../../../redux/actions/menu";
// import { createProductWrapper } from "../../../../../../services/menuApp/menuService";
// import { useRouteMatch } from "react-router-dom";
// import ButtonCommon from "../../../../../../components/buttons/ButtonCommon";
// import { CustomTheme } from "../../../../../../types/customTheme";


// const useStyles = makeStyles((theme: CustomTheme) =>
//   createStyles({
//     autoComplete: {
//       marginTop: "4px",
//       "& .MuiAutocomplete-input": {
//         color: theme.palette.custom.orange.contrastText,
//       },
//       "& .MuiInputBase-root": {
//         color: "inherit",
//         backgroundColor: theme.palette.background.entity_background,
//         borderRadius: 10,
//       },
//       [`& fieldset`]: {
//         borderRadius: 10,
//         border: "none",
//         color: theme.palette.custom.orange.contrastText,
//       },
//     },
//     titleColor: {
//       color: theme.palette.custom.orange.contrastText,
//     },
//     labelStyle: {
//       fontSize: "14px",
//       [theme.breakpoints.down("xs")]: {
//         fontSize: "12px",
//       },
//     },
//   }),
// );

// export interface ProductAddModalProps {
//   isOpen: boolean;
//   setIsOpen: (open: boolean) => void;
//   handleCloseProductAddModal: () => void;
//   stockDepartmentSelectedNode: any[];
//   categoryId: any;
//   directoryId: any;
//   directoryLevel: number;
//   menuNodeList: any;
//   selectedMenuId: string;
//   firstWrapperId: any;
//   setMenuNodeList: (list: any) => void;
//   setSuccess: (message: string) => void;
//   setError: (message: string) => void;
//   isRoot: boolean;
//   menuId: string;
//   setIsOpenDirectoryOrProductSelectionModal: (open: boolean) => void;
//   onItemAdded?: (newItem?: any) => void;
//   wrapperId?: any;
// }

// const ProductAddModal: React.FunctionComponent<ProductAddModalProps> = ({
//   isOpen,
//   setIsOpen,
//   handleCloseProductAddModal,
//   stockDepartmentSelectedNode,
//   categoryId,
//   directoryId,
//   directoryLevel,
//   menuNodeList,
//   selectedMenuId,
//   firstWrapperId,
//   setMenuNodeList,
//   setSuccess,
//   setError,
//   isRoot,
//   menuId,
//   setIsOpenDirectoryOrProductSelectionModal,
//   onItemAdded,
//   wrapperId,
// }) => {
//   const match: any = useRouteMatch();
//   const dispatch = useDispatch();
//   const [selectedDepartmentObj, setSelectedDepartmentObj] = useState<any>({});
//   const [isDepartmentEmpty, setIsDepartmentEmpty] = useState(false);
//   const [isLoadingButton, setIsLoadingButton] = useState(false);
//   const [open, setOpen] = useState(false);

//   // Initialize react-hook-form
//   const {
//     register,
//     handleSubmit,
//     reset,
//     formState: { errors },
//   } = useForm<any>({
//     defaultValues: {
//       name: "",
//       plu: "",
//       barcode: "",
//       upcBarcode: "",
//       nameShort: "",
//     },
//   });

//   // Helper function to extract ID from categoryId (handles both number and object)
//   const getCategoryIdValue = (catId: any): number => {
//     if (!catId) return 0;
//     if (typeof catId === "number") return catId;
//     if (typeof catId === "object" && catId.id) return catId.id;
//     return 0;
//   };

//   // Reset form when modal opens
//   useEffect(() => {
//     if (isOpen) {
//       reset({ name: "", plu: "", barcode: "", upcBarcode: "", nameShort: "" });
//       setSelectedDepartmentObj({});
//       setIsDepartmentEmpty(false);
//     }
//   }, [isOpen, reset]);

//   const handleDepartmentChange = (e: any, departmentData: any) => {
//     setIsDepartmentEmpty(false);
//     setSelectedDepartmentObj(departmentData);
//   };

//   const handleOpenDepartmentAddModal = () => {
//     // Handle add new department if needed
//     console.log("Open add department modal");
//   };

//   const onSubmit = async (data: any) => {
//     const { plu, barcode, upcBarcode, nameShort, name } = data;

//     if (!selectedDepartmentObj?.id) {
//       setIsDepartmentEmpty(true);
//       return;
//     }

//     setIsLoadingButton(true);

//     // Get the actual category ID value (handles both number and object)
//     const actualCategoryId = getCategoryIdValue(categoryId);

//     // Correct body structure matching the API example
//     let body: any = {
//       name: name,
//       nameShort: nameShort || "",
//       locationId: match.params.locationId,
//       valid: true,
//       plu: plu || "",
//       extId: "",
//       barcode: barcode || "",
//       upcBarcode: upcBarcode || "",
//       departmentId: selectedDepartmentObj.id,
//       categoryId: actualCategoryId,
//       globalProductId: "",
//     };

//     // Add directory fields only if not root
//     if (!isRoot) {
//       body.directoryId = directoryId;
//       body.directoryLevel = directoryLevel;
//     }

//     try {
//       const summaryString = `${name} Product wrapper is added`;

//       const res = await createProductWrapper(
//         match.params.locationId,
//         body,
//         "Menus Changed",
//         summaryString,
//         "menu",
//       );

//       const cloneMenuNodeList = _.cloneDeep(menuNodeList);

//       // Get the new product from response
//       let newProduct = res.data.data;
//       if (newProduct.categoryId && typeof newProduct.categoryId === "object") {
//         newProduct = {
//           ...newProduct,
//           categoryId: newProduct.categoryId.id,
//         };
//       }
//       if (
//         newProduct.itemWrapperId?.categoryId &&
//         typeof newProduct.itemWrapperId.categoryId === "object"
//       ) {
//         newProduct.itemWrapperId.categoryId =
//           newProduct.itemWrapperId.categoryId.id;
//       }

//       // Update Redux store directly with the response data
//       if (newProduct && newProduct.itemWrapperId) {
//         const newProductForRedux = {
//           id: newProduct.itemWrapperId.id,
//           valid: newProduct.itemWrapperId.valid,
//           version: newProduct.itemWrapperId.version,
//           name: newProduct.itemWrapperId.name,
//           colour: newProduct.itemWrapperId.colour,
//           img: newProduct.itemWrapperId.img,
//           desc: newProduct.itemWrapperId.desc,
//           directory: newProduct.itemWrapperId.directory,
//           directoryId: newProduct.itemWrapperId.directoryId,
//           directoryLevel: newProduct.itemWrapperId.directoryLevel,
//           itemType: newProduct.itemWrapperId.itemType,
//           allYouCanEat: newProduct.itemWrapperId.allYouCanEat,
//           kiosk: newProduct.itemWrapperId.kiosk,
//           cover: newProduct.itemWrapperId.cover,
//           nameShort: newProduct.itemWrapperId.nameShort,
//           viewOrder: newProduct.itemWrapperId.viewOrder,
//         };
//         dispatch(updateDirectoryInStore(newProductForRedux));
//       }

//       // Find and update the product name in local state
//       if (isRoot) {
//         if (!cloneMenuNodeList[selectedMenuId]?.category[actualCategoryId]?.wrapper) {
//           if (!cloneMenuNodeList[selectedMenuId])
//             cloneMenuNodeList[selectedMenuId] = {};
//           if (!cloneMenuNodeList[selectedMenuId].category)
//             cloneMenuNodeList[selectedMenuId].category = {};
//           if (!cloneMenuNodeList[selectedMenuId].category[actualCategoryId])
//             cloneMenuNodeList[selectedMenuId].category[actualCategoryId] = {};
//           if (!cloneMenuNodeList[selectedMenuId].category[actualCategoryId].wrapper) {
//             cloneMenuNodeList[selectedMenuId].category[actualCategoryId].wrapper = {};
//           }
//         }
//         cloneMenuNodeList[selectedMenuId].category[actualCategoryId].wrapper[
//           newProduct.itemWrapperId.id
//         ] = newProduct.itemWrapperId;
//       } else {
//         const updateProductName = (node: any): boolean => {
//           if (node && node.id === wrapperId) {
//             if (!node?.wrapper) {
//               node.wrapper = {};
//             }
//             node.wrapper[newProduct.itemWrapperId.id] = newProduct.itemWrapperId;
//             return true;
//           }

//           if (node && node.wrapper) {
//             for (const key in node.wrapper) {
//               if (Object.hasOwnProperty.call(node.wrapper, key)) {
//                 const child = node.wrapper[key];
//                 if (updateProductName(child)) {
//                   return true;
//                 }
//               }
//             }
//           }
//           return false;
//         };

//         if (
//           cloneMenuNodeList[menuId] &&
//           cloneMenuNodeList[menuId].category[actualCategoryId]
//         ) {
//           const parentWrapper =
//             cloneMenuNodeList[menuId].category[actualCategoryId].wrapper;
//           if (parentWrapper && parentWrapper[firstWrapperId]) {
//             updateProductName(parentWrapper[firstWrapperId]);
//           }
//         }
//       }

//       setMenuNodeList(cloneMenuNodeList);
//       setIsLoadingButton(false);
//       setIsOpen(false);
//       setIsOpenDirectoryOrProductSelectionModal(false);
//       setSuccess(SUCCESSFULLY_CREATED);

//       if (onItemAdded) {
//         onItemAdded(newProduct);
//       }
//     } catch (err) {
//       console.error("ProductAddModal - Error:", err);
//       setIsLoadingButton(false);
//       setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
//     }
//   };

//   const classes = useStyles();

//   return (
//     <>
//       <DialogCommonDefault
//         open={isOpen}
//         setOpen={setIsOpen}
//         isNeedFixedHeight={false}
//       >
//         <DialogTitle>Add New Product</DialogTitle>
//         <DialogContent>
//           <Grid container>
//             <Grid item xs={12}>
//               <Typography style={{ paddingLeft: "4px" }}>Name</Typography>
//               <TextfieldDefaultNew
//                 id="name"
//                 name="name"
//                 type="text"
//                 inputRef={register({
//                   required: "Name is required",
//                 })}
//               />
//               {errors.name ? (
//                 <ValidationMessage message={errors.name?.message} />
//               ) : (
//                 ""
//               )}
//             </Grid>

//             <Grid
//               item
//               xs={12}
//               style={{ marginTop: "12px", marginBottom: "12px" }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                 }}
//               >
//                 <Typography>Select Department</Typography>
//                 <Button
//                   style={{ textTransform: "none" }}
//                   color="secondary"
//                   autoFocus
//                   onClick={handleOpenDepartmentAddModal}
//                 >
//                   {"Add new department"}
//                 </Button>
//               </div>
//               <Autocomplete
//                 open={open}
//                 onOpen={() => setOpen(true)}
//                 onClose={() => setOpen(false)}
//                 size={"small"}
//                 id="locationSelectGlobal"
//                 color="inherit"
//                 options={stockDepartmentSelectedNode || []}
//                 value={selectedDepartmentObj}
//                 getOptionLabel={(option: any) => option?.name || ""}
//                 style={{ width: 300 }}
//                 disableClearable
//                 onChange={handleDepartmentChange}
//                 classes={{ root: classes.autoComplete }}
//                 popupIcon={<ArrowDropDownIcon color={"inherit"} />}
//                 renderOption={(props: any) => {
//                   return (
//                     <Grid
//                       container
//                       {...props}
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         zIndex: 0,
//                         height: "20px",
//                         marginBottom: "4px",
//                       }}
//                     >
//                       <Grid item xs={12}>
//                         <Typography
//                           variant="body2"
//                           className={classes.titleColor}
//                         >
//                           {props?.name}
//                         </Typography>
//                       </Grid>
//                     </Grid>
//                   );
//                 }}
//                 renderInput={(params: any) => (
//                   <TextField
//                     color="inherit"
//                     {...params}
//                     label=""
//                     placeholder="Select Department"
//                     variant="outlined"
//                   />
//                 )}
//               />
//               {isDepartmentEmpty ? (
//                 <ValidationMessage message={"Department is required"} />
//               ) : (
//                 ""
//               )}
//             </Grid>

//             <Grid item xs={12}>
//               <Typography style={{ paddingLeft: "4px" }}>PLU</Typography>
//               <TextfieldDefaultNew
//                 id="plu"
//                 name="plu"
//                 type="text"
//                 inputRef={register({
//                   required: false,
//                 })}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <Typography style={{ paddingLeft: "4px" }}>Barcode</Typography>
//               <TextfieldDefaultNew
//                 id="barcode"
//                 name="barcode"
//                 type="text"
//                 inputRef={register({
//                   required: false,
//                 })}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <Typography style={{ paddingLeft: "4px" }}>
//                 UPC Barcode
//               </Typography>
//               <TextfieldDefaultNew
//                 id="upcBarcode"
//                 name="upcBarcode"
//                 type="text"
//                 inputRef={register({
//                   required: false,
//                 })}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <Typography style={{ paddingLeft: "4px" }}>Name Short</Typography>
//               <TextfieldDefaultNew
//                 id="nameShort"
//                 name="nameShort"
//                 type="text"
//                 inputRef={register({
//                   required: false,
//                 })}
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions style={{ marginBottom: "8px" }}>
//           <ButtonCommon
//             variant="contained"
//             style={{ fontSize: 11, width: "100px", marginRight: 8 }}
//             color="yellow"
//             onClick={handleCloseProductAddModal}
//           >
//             Cancel
//           </ButtonCommon>
//           <ButtonCommon
//             variant="contained"
//             style={{
//               fontSize: 11,
//               marginLeft: 4,
//               width: "100px",
//             }}
//             isLoadingPage={isLoadingButton}
//             color={"green"}
//             onClick={handleSubmit(onSubmit)}
//           >
//             {"Create"}
//           </ButtonCommon>
//         </DialogActions>
//       </DialogCommonDefault>
//     </>
//   );
// };

// export default ProductAddModal;


import React, { useEffect, useState } from "react";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
  createStyles,
  makeStyles,
} from "@material-ui/core";
import _ from "lodash";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import ValidationMessage from "../../../../../../components/validation/ValidationMessage";
import DialogCommonDefault from "../../../../../../components/dialogs/DialogCommonDefault";
import TextfieldDefaultNew from "../../../../../../components/textField/TextfieldDefaultNew";
import { Autocomplete } from "@material-ui/lab";
import { ERROR_MESSAGE_UNEXPECTED_ERROR, SUCCESSFULLY_CREATED } from "../../../../../../utils/consts";
import { updateDirectoryInStore } from "../../../../../../redux/actions/menu";
import { createProductWrapper } from "../../../../../../services/menuApp/menuService";
import { useRouteMatch } from "react-router-dom";
import ButtonCommon from "../../../../../../components/buttons/ButtonCommon";
import { CustomTheme } from "../../../../../../types/customTheme";

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    autoComplete: {
      marginTop: "4px",
      "& .MuiAutocomplete-input": {
        color: theme.palette.custom.orange.contrastText,
      },
      "& .MuiInputBase-root": {
        color: "inherit",
        backgroundColor: theme.palette.background.entity_background,
        borderRadius: 10,
      },
      [`& fieldset`]: {
        borderRadius: 10,
        border: "none",
        color: theme.palette.custom.orange.contrastText,
      },
    },
    titleColor: {
      color: theme.palette.custom.orange.contrastText,
    },
    labelStyle: {
      fontSize: "14px",
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px",
      },
    },
  }),
);

export interface ProductAddModalProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  handleCloseProductAddModal: () => void;
  stockDepartmentSelectedNode: any[];
  categoryId: any;
  directoryId: any;
  directoryLevel: number;
  menuNodeList: any;
  selectedMenuId: string;
  firstWrapperId: any;
  setMenuNodeList: (list: any) => void;
  setSuccess: (message: string) => void;
  setError: (message: string) => void;
  isRoot: boolean;
  menuId: string;
  setIsOpenDirectoryOrProductSelectionModal: (open: boolean) => void;
  onItemAdded?: (newItem?: any) => void;
  wrapperId?: any;
}

const ProductAddModal: React.FunctionComponent<ProductAddModalProps> = ({
  isOpen,
  setIsOpen,
  handleCloseProductAddModal,
  stockDepartmentSelectedNode,
  categoryId,
  directoryId,
  directoryLevel,
  menuNodeList,
  selectedMenuId,
  firstWrapperId,
  setMenuNodeList,
  setSuccess,
  setError,
  isRoot,
  menuId,
  setIsOpenDirectoryOrProductSelectionModal,
  onItemAdded,
  wrapperId,
}) => {
  const match: any = useRouteMatch();
  const dispatch = useDispatch();
  const [selectedDepartmentObj, setSelectedDepartmentObj] = useState<any>({});
  const [isDepartmentEmpty, setIsDepartmentEmpty] = useState(false);
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [open, setOpen] = useState(false);
  const [isOpenDepartmentAddModal, setIsOpenDepartmentAddModal] = useState(false);

  // Initialize react-hook-form
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      name: "",
      plu: "",
      barcode: "",
      upcBarcode: "",
      nameShort: "",
    },
  });

  // Helper function to extract ID from categoryId (handles both number and object)
  const getCategoryIdValue = (catId: any): number => {
    if (!catId) return 0;
    if (typeof catId === "number") return catId;
    if (typeof catId === "object" && catId.id) return catId.id;
    return 0;
  };

  // Helper function to normalize response data
  const normalizeResponseData = (data: any): any => {
    const normalized = { ...data };
    
    // Handle categoryId if it's an object
    if (normalized.categoryId && typeof normalized.categoryId === "object") {
      normalized.categoryId = normalized.categoryId.id;
    }
    
    // Handle itemWrapperId if it exists
    if (normalized.itemWrapperId) {
      if (normalized.itemWrapperId.categoryId && typeof normalized.itemWrapperId.categoryId === "object") {
        normalized.itemWrapperId.categoryId = normalized.itemWrapperId.categoryId.id;
      }
    }
    
    return normalized;
  };

  // Reset form when modal opens
  useEffect(() => {
    if (isOpen) {
      reset({ name: "", plu: "", barcode: "", upcBarcode: "", nameShort: "" });
      setSelectedDepartmentObj({});
      setIsDepartmentEmpty(false);
    }
  }, [isOpen, reset]);

  const handleDepartmentChange = (e: any, departmentData: any) => {
    setIsDepartmentEmpty(false);
    setSelectedDepartmentObj(departmentData);
  };

  const handleDepartmentAdded = (newDepartment: any) => {
    // Update the stockDepartmentSelectedNode with the new department
    // This will be handled by the parent component
    setSelectedDepartmentObj(newDepartment);
    setIsDepartmentEmpty(false);
    // Close the department add modal
    setIsOpenDepartmentAddModal(false);
    // Success message
    setSuccess("Department added successfully");
    setTimeout(() => setSuccess(""), 2000);
  };

  const handleOpenDepartmentAddModal = () => {
    setIsOpenDepartmentAddModal(true);
  };

  const handleCloseDepartmentAddModal = () => {
    setIsOpenDepartmentAddModal(false);
  };

  const onSubmit = async (data: any) => {
    const { plu, barcode, upcBarcode, nameShort, name } = data;

    if (!selectedDepartmentObj?.id) {
      setIsDepartmentEmpty(true);
      return;
    }

    setIsLoadingButton(true);

    // Get the actual category ID value (handles both number and object)
    const actualCategoryId = getCategoryIdValue(categoryId);

    let body: any = {
      name: name,
      nameShort: nameShort || "",
      locationId: match.params.locationId,
      valid: true,
      plu: plu || "",
      extId: "",
      barcode: barcode || "",
      upcBarcode: upcBarcode || "",
      departmentId: selectedDepartmentObj.id,
      categoryId: actualCategoryId,
    };

    // Add directory fields only if not root
    if (!isRoot) {
      body.directoryId = directoryId;
      body.directoryLevel = directoryLevel;
    }

    try {
      const summaryString = `${name} Product wrapper is added`;

      const res = await createProductWrapper(
        match.params.locationId,
        body,
        "Menus Changed",
        summaryString,
        "menu",
      );

      const cloneMenuNodeList = _.cloneDeep(menuNodeList);

      // Get the new product from response and normalize
      let newProduct = normalizeResponseData(res.data.data);
      
      // The created item is directly the wrapper data
      const newWrapper = newProduct;
      
      // Update Redux store directly with the response data
      const newItemForRedux = {
        id: newWrapper.id,
        valid: newWrapper.valid !== undefined ? newWrapper.valid : true,
        version: newWrapper.version || 0,
        name: newWrapper.name,
        colour: newWrapper.colour || "",
        img: newWrapper.img || "",
        desc: newWrapper.desc || "",
        directory: newWrapper.directory === true || newWrapper.directory === "true",
        directoryId: newWrapper.directoryId || -99,
        directoryLevel: newWrapper.directoryLevel || 1,
        itemType: newWrapper.itemType || "starters",
        allYouCanEat: newWrapper.allYouCanEat || false,
        kiosk: newWrapper.kiosk || 1,
        cover: newWrapper.cover || "",
        nameShort: newWrapper.nameShort || "",
        viewOrder: newWrapper.viewOrder || 0,
      };
      
      dispatch(updateDirectoryInStore(newItemForRedux));

      // Find and update the product name in local state
      if (isRoot) {
        if (!cloneMenuNodeList[selectedMenuId]?.category[actualCategoryId]?.wrapper) {
          if (!cloneMenuNodeList[selectedMenuId]) cloneMenuNodeList[selectedMenuId] = {};
          if (!cloneMenuNodeList[selectedMenuId].category)
            cloneMenuNodeList[selectedMenuId].category = {};
          if (!cloneMenuNodeList[selectedMenuId].category[actualCategoryId])
            cloneMenuNodeList[selectedMenuId].category[actualCategoryId] = {};
          if (!cloneMenuNodeList[selectedMenuId].category[actualCategoryId].wrapper) {
            cloneMenuNodeList[selectedMenuId].category[actualCategoryId].wrapper = {};
          }
        }
        cloneMenuNodeList[selectedMenuId].category[actualCategoryId].wrapper[
          newWrapper.id
        ] = newWrapper;
      } else {
        const updateProductName = (node: any): boolean => {
          if (node && node.id === wrapperId) {
            if (!node?.wrapper) {
              node.wrapper = {};
            }
            node.wrapper[newWrapper.id] = newWrapper;
            return true;
          }

          if (node && node.wrapper) {
            for (const key in node.wrapper) {
              if (Object.hasOwnProperty.call(node.wrapper, key)) {
                const child = node.wrapper[key];
                if (updateProductName(child)) {
                  return true;
                }
              }
            }
          }
          return false;
        };

        if (
          cloneMenuNodeList[menuId] &&
          cloneMenuNodeList[menuId].category[actualCategoryId]
        ) {
          const parentWrapper =
            cloneMenuNodeList[menuId].category[actualCategoryId].wrapper;
          if (parentWrapper && parentWrapper[firstWrapperId]) {
            updateProductName(parentWrapper[firstWrapperId]);
          }
        }
      }

      setMenuNodeList(cloneMenuNodeList);
      setIsLoadingButton(false);
      setIsOpen(false);
      setIsOpenDirectoryOrProductSelectionModal(false);
      setSuccess(SUCCESSFULLY_CREATED);

      if (onItemAdded) {
        onItemAdded(newWrapper);
      }
    } catch (err) {
      console.error("ProductAddModal - Error:", err);
      setIsLoadingButton(false);
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
    }
  };

  const classes = useStyles();

  return (
    <>
      <DialogCommonDefault
        open={isOpen}
        setOpen={setIsOpen}
        isNeedFixedHeight={false}
      >
        <DialogTitle>Add New Product</DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12}>
              <Typography style={{ paddingLeft: "4px" }}>Name</Typography>
              <TextfieldDefaultNew
                id="name"
                name="name"
                type="text"
                inputRef={register({
                  required: "Name is required",
                })}
              />
              {errors.name ? (
                <ValidationMessage message={errors.name?.message} />
              ) : (
                ""
              )}
            </Grid>

            <Grid
              item
              xs={12}
              style={{ marginTop: "12px", marginBottom: "12px" }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography>Select Department</Typography>
                <Button
                  style={{ textTransform: "none" }}
                  color="secondary"
                  autoFocus
                  onClick={handleOpenDepartmentAddModal}
                >
                  {"Add new department"}
                </Button>
              </div>
              <Autocomplete
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                size={"small"}
                id="locationSelectGlobal"
                color="inherit"
                options={stockDepartmentSelectedNode || []}
                value={selectedDepartmentObj}
                getOptionLabel={(option: any) => option?.name || ""}
                style={{ width: 300 }}
                disableClearable
                onChange={handleDepartmentChange}
                classes={{ root: classes.autoComplete }}
                popupIcon={<ArrowDropDownIcon color={"inherit"} />}
                renderOption={(props: any) => {
                  return (
                    <Grid
                      container
                      {...props}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        zIndex: 0,
                        height: "20px",
                        marginBottom: "4px",
                      }}
                    >
                      <Grid item xs={12}>
                        <Typography
                          variant="body2"
                          className={classes.titleColor}
                        >
                          {props?.name}
                        </Typography>
                      </Grid>
                    </Grid>
                  );
                }}
                renderInput={(params: any) => (
                  <TextField
                    color="inherit"
                    {...params}
                    label=""
                    placeholder="Select Department"
                    variant="outlined"
                  />
                )}
              />
              {isDepartmentEmpty ? (
                <ValidationMessage message={"Department is required"} />
              ) : (
                ""
              )}
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ paddingLeft: "4px" }}>PLU</Typography>
              <TextfieldDefaultNew
                id="plu"
                name="plu"
                type="text"
                inputRef={register({
                  required: false,
                })}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ paddingLeft: "4px" }}>Barcode</Typography>
              <TextfieldDefaultNew
                id="barcode"
                name="barcode"
                type="text"
                inputRef={register({
                  required: false,
                })}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ paddingLeft: "4px" }}>
                UPC Barcode
              </Typography>
              <TextfieldDefaultNew
                id="upcBarcode"
                name="upcBarcode"
                type="text"
                inputRef={register({
                  required: false,
                })}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ paddingLeft: "4px" }}>Name Short</Typography>
              <TextfieldDefaultNew
                id="nameShort"
                name="nameShort"
                type="text"
                inputRef={register({
                  required: false,
                })}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ marginBottom: "8px" }}>
          <ButtonCommon
            variant="contained"
            style={{ fontSize: 11, width: "100px", marginRight: 8 }}
            color="yellow"
            onClick={handleCloseProductAddModal}
          >
            Cancel
          </ButtonCommon>
          <ButtonCommon
            variant="contained"
            style={{
              fontSize: 11,
              marginLeft: 4,
              width: "100px",
            }}
            isLoadingPage={isLoadingButton}
            color={"green"}
            onClick={handleSubmit(onSubmit)}
          >
            {"Create"}
          </ButtonCommon>
        </DialogActions>
      </DialogCommonDefault>

    </>
  );
};

export default ProductAddModal;